// Datos mock del piloto. Todo el estado vive en memoria (AppContext).
// Cuando se conecte el backend, esto se reemplaza por un services/api.js.

export const CATEGORIAS = [
  { id: 'fruver', nombre: 'Fruver', emoji: '🥭' },
  { id: 'market', nombre: 'Market', emoji: '🛒' },
  { id: 'drogueria', nombre: 'Droguería', emoji: '💊' },
  { id: 'panaderia', nombre: 'Panadería', emoji: '🥖' },
  { id: 'comida', nombre: 'Comida preparada', emoji: '🫔' },
  { id: 'carreta', nombre: 'Carreta / puesto', emoji: '🥑' },
];

export const NEGOCIOS_INICIALES = [
  {
    id: 'n-01',
    nombre: 'Fruver La Esquina',
    categoria: 'fruver',
    ubicacion: 'Cra. 33 con Cll. 45, Cabecera',
    horario: 'Lun–Sáb · 6:30 am – 8:00 pm',
    telefono: '3155550001',
    correo: 'fruver@holaveci.co',
    contrasena: 'hola1234',
    planId: 'plan-tendero',
    activo: true,
    color: '#0F4C3A',
  },
  {
    id: 'n-02',
    nombre: 'Market Doña Fanny',
    categoria: 'market',
    ubicacion: 'Cll. 48 #34-12, Sotomayor',
    horario: 'Todos los días · 7:00 am – 10:00 pm',
    telefono: '3155550002',
    correo: 'market@holaveci.co',
    contrasena: 'hola1234',
    planId: 'plan-tendero',
    activo: true,
    color: '#8B3A2C',
  },
  {
    id: 'n-03',
    nombre: 'Droguería El Vecino',
    categoria: 'drogueria',
    ubicacion: 'Cra. 35 #47-22',
    horario: 'Lun–Dom · 7:00 am – 11:00 pm',
    telefono: '3155550003',
    correo: 'drogueria@holaveci.co',
    contrasena: 'hola1234',
    planId: 'plan-barrio-pro',
    activo: true,
    color: '#3A6EA5',
  },
  {
    id: 'n-04',
    nombre: 'Tamales de Doña Otilia',
    categoria: 'comida',
    ubicacion: 'Cll. 46 con Cra. 34',
    horario: 'Sáb y Dom · 7:00 am – 12:00 m',
    telefono: '3155550004',
    activo: true,
    color: '#C9902A',
  },
  {
    id: 'n-05',
    nombre: 'Carreta de Aguacates de Don Julio',
    categoria: 'carreta',
    ubicacion: 'Cra. 33 con Cll. 47 (esquina)',
    horario: 'Lun–Vie · 9:00 am – 6:00 pm',
    telefono: '3155550005',
    activo: true,
    color: '#2E7D5B',
  },
  {
    id: 'n-06',
    nombre: 'Panadería La Vecinita',
    categoria: 'panaderia',
    ubicacion: 'Cll. 45 #32-08',
    horario: 'Lun–Dom · 5:30 am – 9:00 pm',
    telefono: '3155550006',
    activo: true,
    color: '#E85D3B',
  },
];

// Productos por negocio. Precios en COP redondeados.
export const PRODUCTOS_INICIALES = [
  // Fruver La Esquina
  { id: 'p-101', negocioId: 'n-01', nombre: 'Aguacate Hass (unidad)', precio: 3500, disponible: true, unidad: 'un' },
  { id: 'p-102', negocioId: 'n-01', nombre: 'Tomate chonto (libra)', precio: 2800, disponible: true, unidad: 'lb' },
  { id: 'p-103', negocioId: 'n-01', nombre: 'Cebolla cabezona (libra)', precio: 2500, disponible: true, unidad: 'lb' },
  { id: 'p-104', negocioId: 'n-01', nombre: 'Mango tommy (libra)', precio: 3200, disponible: true, unidad: 'lb' },
  { id: 'p-105', negocioId: 'n-01', nombre: 'Piña gold (unidad)', precio: 6000, disponible: true, unidad: 'un' },
  { id: 'p-106', negocioId: 'n-01', nombre: 'Banano criollo (libra)', precio: 1800, disponible: false, unidad: 'lb' },
  { id: 'p-107', negocioId: 'n-01', nombre: 'Lechuga crespa (unidad)', precio: 2200, disponible: true, unidad: 'un' },
  { id: 'p-108', negocioId: 'n-01', nombre: 'Zanahoria (libra)', precio: 2000, disponible: true, unidad: 'lb' },

  // Market Doña Fanny
  { id: 'p-201', negocioId: 'n-02', nombre: 'Arroz Diana 500 g', precio: 3400, disponible: true, unidad: 'un', codigoBarras: '7702001010012' },
  { id: 'p-202', negocioId: 'n-02', nombre: 'Aceite Girasol 500 ml', precio: 8500, disponible: true, unidad: 'un', codigoBarras: '7702011045208' },
  { id: 'p-203', negocioId: 'n-02', nombre: 'Leche Alquería 1 L', precio: 4700, disponible: true, unidad: 'un', codigoBarras: '7702189000019' },
  { id: 'p-204', negocioId: 'n-02', nombre: 'Huevos AA (30 un)', precio: 18500, disponible: true, unidad: 'un', codigoBarras: '7702354000015' },
  { id: 'p-205', negocioId: 'n-02', nombre: 'Panela redonda', precio: 3800, disponible: true, unidad: 'un' },
  { id: 'p-206', negocioId: 'n-02', nombre: 'Chocolate Corona 500 g', precio: 12500, disponible: true, unidad: 'un', codigoBarras: '7702025400218' },

  // Droguería El Vecino
  { id: 'p-301', negocioId: 'n-03', nombre: 'Acetaminofén 500 mg (blíster)', precio: 4500, disponible: true, unidad: 'un', codigoBarras: '7703153100014' },
  { id: 'p-302', negocioId: 'n-03', nombre: 'Ibuprofeno 400 mg (blíster)', precio: 5200, disponible: true, unidad: 'un', codigoBarras: '7703153200011' },
  { id: 'p-303', negocioId: 'n-03', nombre: 'Alcohol antiséptico 250 ml', precio: 6800, disponible: true, unidad: 'un', codigoBarras: '7702046030018' },
  { id: 'p-304', negocioId: 'n-03', nombre: 'Curas surtidas (caja x20)', precio: 4200, disponible: true, unidad: 'un', codigoBarras: '7702046040017' },
  { id: 'p-305', negocioId: 'n-03', nombre: 'Suero oral', precio: 3900, disponible: true, unidad: 'un', codigoBarras: '7702046050016' },

  // Tamales
  { id: 'p-401', negocioId: 'n-04', nombre: 'Tamal santandereano', precio: 12000, disponible: true, unidad: 'un' },
  { id: 'p-402', negocioId: 'n-04', nombre: 'Tamal tolimense', precio: 11000, disponible: true, unidad: 'un' },
  { id: 'p-403', negocioId: 'n-04', nombre: 'Envuelto de mazorca', precio: 4500, disponible: true, unidad: 'un' },

  // Aguacates
  { id: 'p-501', negocioId: 'n-05', nombre: 'Aguacate papelillo grande', precio: 5000, disponible: true, unidad: 'un' },
  { id: 'p-502', negocioId: 'n-05', nombre: 'Aguacate papelillo mediano', precio: 3500, disponible: true, unidad: 'un' },
  { id: 'p-503', negocioId: 'n-05', nombre: 'Media docena de aguacate', precio: 18000, disponible: true, unidad: 'un' },

  // Panadería
  { id: 'p-601', negocioId: 'n-06', nombre: 'Pan de yuca (unidad)', precio: 1200, disponible: true, unidad: 'un' },
  { id: 'p-602', negocioId: 'n-06', nombre: 'Almojábana (unidad)', precio: 1500, disponible: true, unidad: 'un' },
  { id: 'p-603', negocioId: 'n-06', nombre: 'Pan aliñado (unidad)', precio: 900, disponible: true, unidad: 'un' },
  { id: 'p-604', negocioId: 'n-06', nombre: 'Roscón con arequipe', precio: 2200, disponible: true, unidad: 'un' },
];

export const VECINOS_INICIALES = [
  { id: 'v-01', nombre: 'Rosa Pérez', telefono: '3155551001', direccion: 'Cll. 46 #33-15 Apto 402', apodo: 'Doña Rosa', correo: 'rosa@holaveci.co', contrasena: 'hola1234' },
  { id: 'v-02', nombre: 'Jaime Rodríguez', telefono: '3155551002', direccion: 'Cra. 34 #47-88', apodo: 'Don Jaime' },
  { id: 'v-03', nombre: 'Luz Marina Ariza', telefono: '3155551003', direccion: 'Cll. 45 #35-12', apodo: 'Luz' },
  { id: 'v-04', nombre: 'Carlos Suárez', telefono: '3155551004', direccion: 'Cra. 33 #48-05', apodo: 'Carlos', correo: 'carlos@holaveci.co', contrasena: 'hola1234' },
  { id: 'v-05', nombre: 'María Fernanda Ortiz', telefono: '3155551005', direccion: 'Cll. 47 #34-22', apodo: 'Mafe' },
];

// Pedidos iniciales — algunos entregados, algunos en curso.
export const PEDIDOS_INICIALES = [
  {
    id: 'ped-001',
    negocioId: 'n-01',
    veciId: 'v-01',
    items: [
      { productoId: 'p-101', nombre: 'Aguacate Hass (unidad)', precio: 3500, cantidad: 3 },
      { productoId: 'p-102', nombre: 'Tomate chonto (libra)', precio: 2800, cantidad: 2 },
    ],
    total: 3500 * 3 + 2800 * 2,
    estado: 'nuevo',
    esFiado: false,
    fecha: hoyMenos(0, 15),
    nota: 'Por favor los tomates bien maduros.',
  },
  {
    id: 'ped-002',
    negocioId: 'n-01',
    veciId: 'v-02',
    items: [
      { productoId: 'p-104', nombre: 'Mango tommy (libra)', precio: 3200, cantidad: 4 },
      { productoId: 'p-107', nombre: 'Lechuga crespa (unidad)', precio: 2200, cantidad: 1 },
    ],
    total: 3200 * 4 + 2200,
    estado: 'preparacion',
    esFiado: true,
    fecha: hoyMenos(0, 45),
    nota: '',
  },
  {
    id: 'ped-003',
    negocioId: 'n-01',
    veciId: 'v-03',
    items: [
      { productoId: 'p-105', nombre: 'Piña gold (unidad)', precio: 6000, cantidad: 1 },
    ],
    total: 6000,
    estado: 'entregado',
    esFiado: false,
    fecha: hoyMenos(1, 0),
    nota: '',
  },
  {
    id: 'ped-004',
    negocioId: 'n-01',
    veciId: 'v-01',
    items: [
      { productoId: 'p-108', nombre: 'Zanahoria (libra)', precio: 2000, cantidad: 3 },
      { productoId: 'p-103', nombre: 'Cebolla cabezona (libra)', precio: 2500, cantidad: 2 },
    ],
    total: 2000 * 3 + 2500 * 2,
    estado: 'entregado',
    esFiado: true,
    fecha: hoyMenos(3, 0),
    nota: '',
  },
  {
    id: 'ped-005',
    negocioId: 'n-02',
    veciId: 'v-01',
    items: [
      { productoId: 'p-203', nombre: 'Leche Alquería 1 L', precio: 4700, cantidad: 2 },
      { productoId: 'p-205', nombre: 'Panela redonda', precio: 3800, cantidad: 1 },
    ],
    total: 4700 * 2 + 3800,
    estado: 'entregado',
    esFiado: true,
    fecha: hoyMenos(2, 0),
    nota: '',
  },
  {
    id: 'ped-006',
    negocioId: 'n-06',
    veciId: 'v-04',
    items: [
      { productoId: 'p-601', nombre: 'Pan de yuca (unidad)', precio: 1200, cantidad: 6 },
      { productoId: 'p-602', nombre: 'Almojábana (unidad)', precio: 1500, cantidad: 4 },
    ],
    total: 1200 * 6 + 1500 * 4,
    estado: 'nuevo',
    esFiado: false,
    fecha: hoyMenos(0, 5),
    nota: 'Recojo yo, gracias.',
  },
];

// Fiados iniciales derivados: por cada pedido esFiado === true, se generó un registro.
export const FIADOS_INICIALES = [
  {
    id: 'fi-001',
    veciId: 'v-02',
    negocioId: 'n-01',
    pedidoId: 'ped-002',
    monto: 3200 * 4 + 2200,
    fecha: hoyMenos(0, 45),
    estado: 'pendiente', // pendiente | pagado
    tipoRegistro: 'pedido', // pedido | escaneado | manual | solo_total
    estadoConfirmacion: 'confirmado', // confirmado | pendiente_confirmacion | reclamado
    descripcion: '',
    items: null, // se toman del pedido
  },
  {
    id: 'fi-002',
    veciId: 'v-01',
    negocioId: 'n-01',
    pedidoId: 'ped-004',
    monto: 2000 * 3 + 2500 * 2,
    fecha: hoyMenos(3, 0),
    estado: 'pendiente',
    tipoRegistro: 'pedido',
    estadoConfirmacion: 'confirmado',
    descripcion: '',
    items: null,
  },
  {
    id: 'fi-003',
    veciId: 'v-01',
    negocioId: 'n-02',
    pedidoId: 'ped-005',
    monto: 4700 * 2 + 3800,
    fecha: hoyMenos(2, 0),
    estado: 'pendiente',
    tipoRegistro: 'pedido',
    estadoConfirmacion: 'confirmado',
    descripcion: '',
    items: null,
  },
  // Fiado manual (venta de mostrador) — pendiente de confirmación del veci
  {
    id: 'fi-004',
    veciId: 'v-01',
    negocioId: 'n-02',
    pedidoId: null,
    monto: 22500,
    fecha: hoyMenos(1, 0),
    estado: 'pendiente',
    tipoRegistro: 'manual',
    estadoConfirmacion: 'pendiente_confirmacion',
    descripcion: 'Venta de mostrador',
    items: [
      { nombre: 'Arroz Diana 500 g', cantidad: 2, precio: 3400 },
      { nombre: 'Aceite Girasol 500 ml', cantidad: 1, precio: 8500 },
      { nombre: 'Huevos AA (30 un)', cantidad: 1, precio: 7200 },
    ],
  },
  // Fiado solo-total — pendiente de confirmación
  {
    id: 'fi-005',
    veciId: 'v-04',
    negocioId: 'n-01',
    pedidoId: null,
    monto: 45000,
    fecha: hoyMenos(1, 0),
    estado: 'pendiente',
    tipoRegistro: 'solo_total',
    estadoConfirmacion: 'pendiente_confirmacion',
    descripcion: 'Mercado del sábado en la mañana',
    items: null,
  },
  // Un fiado antiguo ya pagado, solo para el historial
  {
    id: 'fi-000',
    veciId: 'v-03',
    negocioId: 'n-01',
    pedidoId: null,
    monto: 15000,
    fecha: hoyMenos(20, 0),
    estado: 'pagado',
    tipoRegistro: 'manual',
    estadoConfirmacion: 'confirmado',
    descripcion: 'Verduras variadas',
    items: null,
  },
];

export const PAGOS_INICIALES = [
  {
    id: 'pg-001',
    fiadoId: 'fi-000',
    monto: 15000,
    medio: 'Nequi',
    fecha: hoyMenos(18, 0),
  },
];

// ---------------- MENSAJERÍA ----------------
// Conversación 1-a-1 entre un veci y un negocio. Una sola por par.
// Puede contener mensajes directos y anuncios (campañas). Los anuncios se
// distinguen en la UI y tienen contador de no leídos aparte.
export const CONVERSACIONES_INICIALES = [
  {
    id: 'conv-001',
    veciId: 'v-01',
    negocioId: 'n-01',
    creada: hoyMenos(5, 0),
    actualizada: hoyMenos(0, 30),
    veciSalio: hoyMenos(0, 30),   // última vez que el veci vio la conversación
    negocioSalio: hoyMenos(0, 60), // última vez que el negocio la vio
  },
  {
    id: 'conv-002',
    veciId: 'v-01',
    negocioId: 'n-02',
    creada: hoyMenos(3, 0),
    actualizada: hoyMenos(0, 90),
    veciSalio: hoyMenos(1, 0),
    negocioSalio: hoyMenos(0, 90),
  },
  {
    id: 'conv-003',
    veciId: 'v-04',
    negocioId: 'n-01',
    creada: hoyMenos(1, 0),
    actualizada: hoyMenos(0, 15),
    veciSalio: hoyMenos(1, 0),
    negocioSalio: hoyMenos(1, 0),
  },
];

// tipo: 'directo' | 'anuncio' | 'sistema'
// autor: 'veci' | 'negocio' | 'sistema'
// adjuntos: [{ tipo: 'imagen'|'pdf'|'archivo', nombre, peso, dataUrl }]
export const MENSAJES_INICIALES = [
  // Doña Rosa <-> Fruver La Esquina
  {
    id: 'msg-001',
    conversacionId: 'conv-001',
    autor: 'veci',
    tipo: 'directo',
    texto: 'Buenos días veci, ¿los tomates ya llegaron maduros?',
    adjuntos: [],
    pedidoId: null,
    fecha: hoyMenos(0, 90),
  },
  {
    id: 'msg-002',
    conversacionId: 'conv-001',
    autor: 'negocio',
    tipo: 'directo',
    texto: 'Sí Doña Rosa, salieron perfectos hoy. Le mandé los mejores.',
    adjuntos: [],
    pedidoId: null,
    fecha: hoyMenos(0, 60),
  },
  {
    id: 'msg-003',
    conversacionId: 'conv-001',
    autor: 'veci',
    tipo: 'directo',
    texto: 'Gracias veci, muy amable como siempre.',
    adjuntos: [],
    pedidoId: null,
    fecha: hoyMenos(0, 30),
  },

  // Doña Rosa <-> Market Doña Fanny (con anuncio)
  {
    id: 'msg-004',
    conversacionId: 'conv-002',
    autor: 'negocio',
    tipo: 'anuncio',
    texto: '📣 Este fin de semana: aceite Girasol 500ml a $7.500. Solo hasta el domingo. Pase por acá o pida por la app.',
    adjuntos: [],
    pedidoId: null,
    fecha: hoyMenos(0, 180),
  },
  {
    id: 'msg-005',
    conversacionId: 'conv-002',
    autor: 'veci',
    tipo: 'directo',
    texto: 'Fanny, ¿me llegas a apartar 2 aceites de esos? Paso mañana.',
    adjuntos: [],
    pedidoId: null,
    fecha: hoyMenos(0, 120),
  },
  {
    id: 'msg-006',
    conversacionId: 'conv-002',
    autor: 'negocio',
    tipo: 'directo',
    texto: 'Listo veci, se los aparto. Nos vemos mañana.',
    adjuntos: [],
    pedidoId: null,
    fecha: hoyMenos(0, 90),
  },

  // Carlos <-> Fruver La Esquina (iniciando)
  {
    id: 'msg-007',
    conversacionId: 'conv-003',
    autor: 'negocio',
    tipo: 'directo',
    texto: 'Don Carlos buenas, aquí Fruver La Esquina. Vi que hizo un pedido ayer pero los aguacates estaban muy verdes. ¿Se los cambio?',
    adjuntos: [],
    pedidoId: null,
    fecha: hoyMenos(0, 15),
  },
];

// Bloqueos unidireccionales: negocio → veci. El veci no puede bloquear.
export const BLOQUEOS_INICIALES = [];

// Sesión mock por defecto. La pantalla de landing la puede cambiar.
export const SESION_INICIAL = {
  rol: null,               // 'negocio' | 'veci' | null
  negocioIdActivo: 'n-01', // Fruver La Esquina
  veciIdActivo: 'v-01',    // Doña Rosa
};

// Helper: fecha ISO restando días y minutos.
function hoyMenos(dias, minutos) {
  const d = new Date();
  d.setDate(d.getDate() - dias);
  d.setMinutes(d.getMinutes() - minutos);
  return d.toISOString();
}
